import { AnimatePresence } from 'framer-motion';
import MobileMenuDirectionAnimation from './MobileMenuDirectionAnimation';
import MobileMenuInfo from './MobileMenuInfo';
import {
  NavigationLinkFragment,
  SplashFragment,
  StoreFragment,
} from '@business/gql/graphql';
import { Maybe } from 'graphql/jsutils/Maybe';
import NavSplash from '@ui/components/blocks/NavSplash';

type MobileMenuBottomProps = {
  className?: string;
  locale?: string;
  physicalStores?: Maybe<StoreFragment>[];
  onlineStores?: Maybe<StoreFragment>[];
  additionalNavigation?: Array<NavigationLinkFragment | null>;
  menuLevel?: number;
  onClick?: () => void;
  splash?: SplashFragment | null;
  navigationDirection: 'left' | 'right';
  currentNavigationLevel?: 'campaign';
};

const MobileMenuBottom = ({
  className,
  locale,
  physicalStores,
  onlineStores,
  menuLevel,
  onClick,
  additionalNavigation,
  splash,
  navigationDirection,
  currentNavigationLevel,
}: MobileMenuBottomProps) => {
  const isFirstLevel = menuLevel === 0;

  if (
    isFirstLevel &&
    !physicalStores?.length &&
    !onlineStores?.length &&
    !additionalNavigation
  )
    return null;

  return (
    <div className={className}>
      <AnimatePresence
        initial={false}
        mode="popLayout"
        custom={navigationDirection}>
        {menuLevel === 0 && currentNavigationLevel !== 'campaign' && (
          <MobileMenuDirectionAnimation
            key="mobile-menu-info"
            navigationDirection="left">
            <MobileMenuInfo
              additionalNavigation={additionalNavigation}
              locale={locale}
              physicalStores={physicalStores}
              onlineStores={onlineStores}
              onClick={onClick}
            />
          </MobileMenuDirectionAnimation>
        )}

        {menuLevel === 1 && splash && (
          <MobileMenuDirectionAnimation
            key="mobile-menu-highlights-1"
            navigationDirection={navigationDirection}
            menuLevel={menuLevel}
            className="flex w-full px-[14px] pt-6">
            <div onClick={onClick} className="mb-2 w-full">
              <NavSplash
                key={splash.sys.id}
                locale={locale}
                backdrop
                priority={true}
                {...splash}
              />
            </div>
          </MobileMenuDirectionAnimation>
        )}

        {menuLevel === 2 && splash && (
          <MobileMenuDirectionAnimation
            key="mobile-menu-highlights-2"
            navigationDirection="right"
            menuLevel={menuLevel}
            className="flex w-full px-[14px] pt-6">
            <div onClick={onClick} className="mb-2 w-full">
              <NavSplash
                key={splash.sys.id}
                locale={locale}
                backdrop
                priority={true}
                {...splash}
              />
            </div>
          </MobileMenuDirectionAnimation>
        )}
      </AnimatePresence>
    </div>
  );
};

MobileMenuBottom.displayName = 'MobileMenuBottom';

export default MobileMenuBottom;
